<div class="mat-table-container mb--10">
  <div class="mat-container list">
    <mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="sortTable($event)"
    >
      <ng-container matColumnDef="serialNo">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          Version
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          nowrap
          [ngClass]="getClass(element)"
        >
          <span class="version-text" [matTooltip]="element.serialNo">{{
            element.serialNo
          }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="statusName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          Status
        </mat-header-cell>
        <mat-cell
          class="pl-1"
          *matCellDef="let element"
          [ngClass]="getClass(element)"
        >
          {{ element.statusName }}
          <span
            class="ml-2 error"
            *ngIf="hasMissingSchedule(element)"
            >Error!</span
          >
          <span
            class="ml-2 error"
            *ngIf="element.errors?.length"
            [matTooltip]="service.getErrorsTooltip(element)"
            matTooltipClass="warn-tooltip"
          >
            {{ element.errors.length }}
            {{ element.errors.length == 1 ? "Error" : "Errors" }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="resourceName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="mr-2"
            ><mat-icon class="hidden">help_center</mat-icon></span
          >Resource
        </mat-header-cell>
        <mat-cell
          class="bold"
          *matCellDef="let element"
          [ngClass]="getClass(element)"
        >
          <span
            class="mr-2"
            *ngIf="element.templateType?.scheduleTypeID && element.schedule"
            ><mat-icon
              [ngClass]="getClass(element)"
              class="material-icons-outlined"
              >event_available</mat-icon
            ></span
          >
          <span
            class="mr-2"
            *ngIf="hasMissingSchedule(element)"
            ><mat-icon class="red material-icons-outlined"
              >event_busy</mat-icon
            ></span
          >
          <span
            class="mr-2"
            *ngIf="!element.templateType?.scheduleTypeID && element.resourceID"
            ><mat-icon
              [ngClass]="getClass(element)"
              class="material-icons-outlined"
              >flare</mat-icon
            ></span
          >
          <span
            class="mr-2"
            *ngIf="!element.templateType?.scheduleTypeID && !element.resourceID"
            ><mat-icon class="hidden">help_center</mat-icon></span
          >
          {{ element.resourceString }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="procedureNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          Procedure No.
        </mat-header-cell>
        <mat-cell
          class="bold"
          *matCellDef="let element"
          [ngClass]="getClass(element)"
        >
          {{ element.procedure?.procedureNumber }}
          <span class="small" *ngIf="element.procedure"
            >&nbsp;{{ " Rev." + element.procedure?.revision }}</span
          >
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          Type
        </mat-header-cell>
        <mat-cell
          class="pl-1"
          *matCellDef="let element"
          [ngClass]="getClass(element)"
        >
          {{ element.templateType?.name }}
        </mat-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
      ></mat-header-row>
      <mat-row
        #matrow
        *matRowDef="let row; columns: displayedColumns"
        (click)="rowClicked(row)"
        style="white-space: nowrap"
        [ngClass]="{ 'mat-row-highlight': selectedRowIndex == row.id }"
        [attr.position]="getPosition(row)"
      ></mat-row>
    </mat-table>
  </div>
</div>
